// extracted by mini-css-extract-plugin
export default {"tag":"mU_UD","image":"djPfb","text":"TJ8WK","container":"UiUS7","withAnimation":"nVhWS","animation":"omCl5","codeWrapper":"W_uy7","textWrapper":"eBSAU","discount":"zMB60"};